import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AuthActions } from '../../store';
import './LogoutButton.css';

const logoutIcon = require('./assets/logout-icon.png');

export class LogoutButton extends React.Component {
  handleLogout(e) {
    e.preventDefault();
    this.props.logout();
  }

  renderMobile() {
    return (
      <button type="submit" className="nav-bar-logout" onClick={(e) => this.handleLogout(e)}>
        Log Out
      </button>
    );
  }

  renderDesktop() {
    return (
      <button type="submit" className="nav-bar-logout" onClick={(e) => this.handleLogout(e)}>
        <img className="nav-bar-logout__icon" src={logoutIcon} alt="" />
        <div className="nav-bar-logout__title">Log Out</div>
      </button>
    );
  }

  render() {
    const { mobile = false } = this.props;
    if (mobile) {
      return this.renderMobile();
    }
    return this.renderDesktop();
  }
}

LogoutButton.propTypes = {
  mobile: PropTypes.bool,
  logout: PropTypes.func.isRequired,
};

LogoutButton.defaultProps = { mobile: undefined };

const mapDispatchToProps = {
  logout: AuthActions.logout,
};

const ConnectedLogoutButton = connect(undefined, mapDispatchToProps)(LogoutButton);
export { ConnectedLogoutButton };
